"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var _BrandColors = _interopRequireDefault(require("../Brand/BrandColors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var civicPrimary = _BrandColors["default"].primary.hex;
var civicPlumLight = _BrandColors["default"].plumLight.hex;
var civicMedium = _BrandColors["default"].medium.hex;
var civicSubdued = _BrandColors["default"].subdued.hex;
var civicAction = _BrandColors["default"].action.hex;
var civicError = _BrandColors["default"].error.hex;
var dataSanSerif = "Roboto Condensed, Helvetica Neue, Helvetica, sans-serif";
var sanSerif = "Rubik, Helvetica Neue, Helvetica, sans-serif";
var animationSpeed = 4;
var MaterialTheme = (0, _styles.createMuiTheme)({
  palette: {
    common: {
      black: "rgba(0, 0, 0, 1)",
      white: "#fff"
    },
    background: {
      paper: "rgba(243, 242, 243, 1)",
      "default": "rgba(255, 255, 255, 1)"
    },
    primary: {
      light: civicPlumLight,
      main: civicPrimary,
      dark: civicPrimary,
      contrastText: "#fff"
    },
    secondary: {
      light: civicAction,
      main: civicAction,
      dark: civicAction,
      contrastText: "#fff"
    },
    error: {
      light: civicError,
      main: civicError,
      dark: civicError,
      contrastText: "#fff"
    },
    text: {
      primary: civicPrimary,
      secondary: civicPrimary,
      disabled: civicSubdued,
      hint: civicMedium
    }
  },
  shape: {
    borderRadius: 0
  },
  typography: {
    fontFamily: dataSanSerif,
    button: {
      fontFamily: sanSerif
    },
    h6: {
      fontFamily: sanSerif
    }
  },
  transitions: {
    duration: {
      shortest: 150 / animationSpeed,
      shorter: 200 / animationSpeed,
      "short": 250 / animationSpeed,
      standard: 300 / animationSpeed,
      complex: 375 / animationSpeed,
      enteringScreen: 225 / animationSpeed,
      leavingScreen: 195 / animationSpeed
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  overrides: {
    MuiMenuItem: {
      root: {
        minHeight: "unset",
        lineHeight: "unset"
      }
    }
  }
});
var _default = MaterialTheme;
exports["default"] = _default;